import {
  css
} from 'lit';
export const AccordionToggleStyle = css`
  .toggle-btn {
    width: 100%;
    text-align: left;
    padding-left: var(--lds-spacing-accordion-toggle-padding-left);
    padding-right: var(--lds-spacing-accordion-toggle-padding-right);
    padding-top: calc(var(--lds-spacing-accordion-toggle-padding-top) - var(--lds-border-accordion-header-width));
    padding-bottom: calc(var(--lds-spacing-accordion-toggle-padding-bottom) - var(--lds-border-accordion-header-width));

    border: 0;
    border-color: var(--lds-color-accordion-heading-border);
    border-style: var(--lds-border-accordion-header-style);
    border-bottom-width: var(--lds-border-accordion-header-width);
  }

  .open .toggle-btn {
    border-bottom-color: var(--lds-color-accordion-expanded-heading-border);
  }

  .toggle-btn:focus {
    outline-color: var(--lds-color-accordion-toggle-outline);
    outline-offset: var(--lds-border-accordion-toggle-outline-offset);
    outline-style: var(--lds-border-accordion-toggle-outline-style);
    outline-width: var(--lds-border-accordion-toggle-outline-width);
    box-shadow: var(--lds-shadow-accordion-focus) var(--lds-color-accordion-focus-shadow);
  }

  .lds-accordion-toggle-icon {
    position: absolute;
    top: 50%;
    right: var(--lds-spacing-accordion-toggle-right);
    display: block;
    float: right;
    width: 1.75rem;
    height: 1.75rem;
    border-radius: .75rem;
    transform: translateY(-1rem);
    transition: .35s transform ease, .35s fill ease;
    fill: var(--lds-color-accordion-toggle-icon);
  }

  .lds-accordion-toggle-icon:hover {
    fill: var(--lds-color-accordion-toggle-icon-hover);
  }

  .open .lds-accordion-toggle-icon {
    transform: translateY(-1rem) rotate(180deg);
  }
`;
export default AccordionToggleStyle;
